import { createAction } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const setValidation = createAction('validation/setValidation', (validationField, validationContent) => ({
  payload: {
    validationField,
    validationContent,
  },
}));
